export default __webpack_public_path__ + "static/media/card-fluid-icon.245bedf0.svg";